document.addEventListener('DOMContentLoaded',()=>{document.querySelectorAll('[data-ps-curated]').forEach(section=>{const grid=section.querySelector('[data-ps-grid]');const cards=Array.from(grid.children);const sort=section.querySelector('[data-ps-sort]');const stock=section.querySelector('[data-ps-stock]');const update=()=>{const ordered=cards.slice();if(sort.value!=='featured')ordered.sort((a,b)=>(Number(a.dataset.price)-Number(b.dataset.price))*(sort.value==='high'?-1:1));ordered.forEach(card=>{card.hidden=stock.checked&&card.dataset.available!=='true';grid.append(card)});section.querySelector('[data-ps-empty]').hidden=ordered.some(c=>!c.hidden)};sort.addEventListener('change',update);stock.addEventListener('change',update);update()});document.addEventListener('keydown',e=>{if(e.key==='Escape'){document.querySelectorAll('.ps-header details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus()})}});document.addEventListener('click',e=>{document.querySelectorAll('.ps-header details[open]').forEach(d=>{if(!d.contains(e.target))d.open=false})})});

document.addEventListener('DOMContentLoaded', () => {
  const cartForm = document.querySelector('form[data-ps-cart]');
  if (cartForm) {
    let updating = false;
    cartForm.querySelectorAll('[data-ps-quantity-step]').forEach(button => {
      button.addEventListener('click', () => {
        const input = button.closest('.qtyField').querySelector('input[data-line-key]');
        if (!input || input.disabled) return;
        if (input.value === '') input.value = input.min || '0';
        else if (button.dataset.psQuantityStep === '1') input.stepUp();
        else input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    cartForm.addEventListener('submit', async event => {
      if (event.submitter && event.submitter.name === 'checkout') return;
      event.preventDefault();
      if (updating || !cartForm.reportValidity()) return;
      const fields = Array.from(cartForm.querySelectorAll('input[data-line-key]'));
      const updates = Object.fromEntries(fields.map(input => [input.dataset.lineKey, Number(input.value)]));
      const body = { updates };
      const note = cartForm.querySelector('[name="note"]');
      if (note) body.note = note.value;
      const controls = Array.from(cartForm.querySelectorAll('button[type="submit"],input[type="submit"],input[data-line-key],[data-ps-quantity-step]'));
      const previous = controls.map(control => control.disabled);
      const status = cartForm.querySelector('[data-ps-cart-status]');
      updating = true;
      cartForm.setAttribute('aria-busy', 'true');
      controls.forEach(control => { control.disabled = true; });
      status.hidden = false;
      status.textContent = status.dataset.busy;
      try {
        const response = await fetch(cartForm.dataset.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error('Cart update failed');
        await response.json();
        window.location.assign(cartForm.action);
      } catch (error) {
        updating = false;
        cartForm.removeAttribute('aria-busy');
        controls.forEach((control, index) => { control.disabled = previous[index]; });
        status.textContent = status.dataset.error;
      }
    });
  }
  const languageForm = document.getElementById('PSLanguage');
  if (languageForm) {
    languageForm.addEventListener('submit', () => {
      const returnTo = languageForm.querySelector('input[name="return_to"]');
      if (returnTo) returnTo.value = window.location.pathname + window.location.search;
    });
  }
  document.querySelectorAll('form.product-form').forEach(form => {
    const variants = form.querySelector('select[name="id"]');
    const quantity = form.querySelector('input[name="quantity"]');
    if (!variants || !quantity) return;
    const syncLimit = () => {
      const option = variants.selectedOptions[0];
      const max = option && option.getAttribute('data-ps-max');
      if (max !== null && max !== undefined) quantity.max = max;
      else quantity.removeAttribute('max');
    };
    form.addEventListener('change', () => setTimeout(syncLimit, 0));
    form.addEventListener('submit', event => {
      syncLimit();
      if (!quantity.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    syncLimit();
  });
});
